<template>
    <div class="flex justify-center bg-gray-800">
        <div
            class="font-sans-poppins min-h-screen max-w-3xl w-full flex flex-col"
            :class="{ 'h-screen': isHomepage }"
            :style="{ backgroundColor: propertyHub.site.colors.primary }"
        >
            <transition
                enter-active-class="transition-all duration-[3000]"
                enter-class="opacity-0"
                enter-to-class="opacity-1"
                leave-active-class="transition-all duration-[3000]"
                leave-class="opacity-1"
                leave-to-class="opacity-0"
                mode="out-in"
            >
                <router-view
                    class="relative duration-500 ease-out transition-all flex-[2] pb-10"
                />
            </transition>

            <div
                v-if="showInstallOnHomeScreenPrompt"
                class="fixed top-0 left-0 w-full h-full z-999"
            >
                <div
                    class="blocker absolute top-0 left-0 w-full h-full bg-black opacity-50"
                ></div>
                <div
                    class="absolute bottom-32 absolute-center-x bg-white w-72 py-8 px-4 text-center"
                >
                    <img
                        :src="propertyHub.site.mobileHomeScreenIcon"
                        class="w-12 h-12 absolute -top-6 absolute-center-x rounded-lg"
                    />
                    <h2
                        class="title text-lg my-4"
                        :style="{ color: propertyHub.site.colors.primary }"
                    >
                        Install App
                    </h2>
                    <p>
                        Place our digital concierge app on your home screen for
                        easy fullscreen access.
                    </p>
                    <p v-if="browser === 'safari'" class="text-xs font-normal">
                        Press "Share"
                        <img
                            class="inline w-5 h-6 -my-3 mx-1"
                            src="/pwa/safari-share-btn.png"
                        />
                        below
                    </p>
                    <p
                        v-if="browser === 'safari'"
                        class="text-xs font-normal mb-4"
                    >
                        Then "Add to Home Screen"
                        <img
                            class="inline w-6 h-6 -my-2"
                            src="/pwa/safari-add-btn.png"
                        />
                    </p>
                    <p
                        v-if="browser === 'chrome'"
                        class="text-xs font-normal mb-4"
                    >
                        Press
                        <img
                            v-if="browser === 'chrome'"
                            class="inline w-6 h-6 -my-2"
                            src="/pwa/chrome-settings-btn.png"
                        />
                        then "Add to Home Screen"
                    </p>
                    <button
                        ref="install-button"
                        @click.prevent="dismissInstallOnHomeScreenPrompt"
                        class="rounded-full font-light px-6 py-2 text-sm text-abs-white"
                        :style="{
                            backgroundColor: propertyHub.site.colors.primary,
                        }"
                    >
                        Dismiss
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

const Cookies = require('js-cookie');

export default {
    name: 'PropertyHub',

    data() {
        return {
            sites: [],
            showInstallOnHomeScreenPrompt: false,
        };
    },

    props: {
        devise: {
            type: Object,
            required: true,
        },
    },

    computed: {
        ...mapState(['propertyHub']),

        isHomepage() {
            return this.$route.name === 'property-hub-index';
        },
        mobileOS() {
            var userAgent =
                navigator.userAgent || navigator.vendor || window.opera;

            if (/android/i.test(userAgent)) {
                return true;
            }
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return true;
            }

            return false;
        },
        installedToHomeScreen() {
            if (
                this.mobileOS &&
                this.browser === 'chrome' &&
                window.matchMedia('(display-mode: standalone)').matches
            ) {
                return true;
            }
            if (
                this.mobileOS &&
                this.browser === 'safari' &&
                window.navigator.standalone === true
            ) {
                return true;
            }
            return false;
        },
        browser() {

            // Get the user-agent string
            let userAgentString =
                navigator.userAgent;

            // Detect Chrome
            let chromeAgent =
                userAgentString.indexOf("Chrome") > -1;

            // Detect Internet Explorer
            let IExplorerAgent =
                userAgentString.indexOf("MSIE") > -1 ||
                userAgentString.indexOf("rv:") > -1;

            // Detect Firefox
            let firefoxAgent =
                userAgentString.indexOf("Firefox") > -1;

            // Detect Safari
            let safariAgent =
                userAgentString.indexOf("Safari") > -1;

            // Discard Safari since it also matches Chrome
            if ((chromeAgent) && (safariAgent))
                safariAgent = false;

            // Detect Opera
            let operaAgent =
                userAgentString.indexOf("OP") > -1;

            // Discard Chrome since it also matches Opera     
            if ((chromeAgent) && (operaAgent))
                chromeAgent = false;

            if(safariAgent) return 'safari';
            if(chromeAgent) return 'chrome';
            if(IExplorerAgent) return 'ie';
            if(operaAgent) return 'opera';
            if (firefoxAgent) return 'firefox';

            return 'unknown';
        }
    },
    created() {
        this.sites = propertyHubSites;
        const currentSite = this.getCurrentSite();
        if (!currentSite) {
            console.warn(
                'No site found for this domain. Update the domain list.'
            );
        }

        if (currentSite) {
            document.title = currentSite.name;
            this.$store.commit('setSite', currentSite);
        }
    },
    mounted() {
        if (!this.$route.name || !this.$route.name.includes('property-hub')) {
            this.$router.push('/property-hub');
        }
        this.$store.commit('setMenuLink', this.devise.menuLink);
        this.$store.commit('setEsMenuLink', this.devise.esMenuLink);

        if (this.mobileOS) {
            this.handleInstallFunctionality();
        }
    },

    methods: {
        getCurrentSite() {
            const baseUrl = window.location.host;
            return this.sites.find((site) => {
                if (site.domains.includes(baseUrl)) {
                    return site;
                }
            });
        },
        handleInstallFunctionality() {
            const installPromptDismissed = Cookies.get(
                'install-prompt-dismissed'
            );

            if (
                typeof installPromptDismissed === 'undefined' &&
                this.installedToHomeScreen === false
            ) {
                this.showInstallOnHomeScreenPrompt = true;
            }
        },
        dismissInstallOnHomeScreenPrompt() {
            this.showInstallOnHomeScreenPrompt = false;
            Cookies.set('install-prompt-dismissed', true);
        },
    },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
    opacity: 0;
}
</style>
